import {PageFragment, PageFragmentProps, PageFragmentState} from "../shared/PageFragment";
import React, {ReactElement} from "react";
import {StyledContainer} from "../shared/StyledComponents";

export type BaseTitleFragmentProps = PageFragmentProps & {}

export type BaseTitleFragmentState = PageFragmentState & {}

export abstract class BaseTitleFragment<P extends BaseTitleFragmentProps = BaseTitleFragmentProps, S extends BaseTitleFragmentState = BaseTitleFragmentState> extends PageFragment<P, S> {

  protected getIntrinsicHeight(): number | string {
    return null;
  }

  protected abstract renderPageContent(): ReactElement;

  renderContent(): React.ReactElement | null {
    return <StyledContainer size="xxlg" style={{flexGrow: 1}}>
      {this.renderPageContent()}
    </StyledContainer>
  }
}